export default __webpack_public_path__ + "static/media/clock.52cc6455.svg";